module.exports = __webpack_public_path__ + "media/images/footer-pinterest-icon-0df110719c26034592b20ea6c80b7c78.png";